import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cn from 'classnames';
import { isEditionTrayReadyOrError } from '../../selectors';
import ArticlesFragment from './ArticlesFragment';
import SideScroller from '../Scrollers/SideScroller';
import { containerStyle } from '../../styles/tiles';
import TrayToolbar from '../TrayToolbar';

const Articles = ({
  classes, className, ready, sliceId, colourTheme,
}) => (
  [
    <TrayToolbar key="toolbar" sliceId={sliceId} colourTheme={colourTheme} />,
    <SideScroller
      key="sideScroller"
      className={cn(className, classes.articles)}
      ready={ready}
      slideClassName={classes.article}
      colourTheme={colourTheme}
    >
      <ArticlesFragment articleClassName={classes.article} sliceId={sliceId} />
    </SideScroller>,
  ]
);

Articles.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  ready: PropTypes.bool.isRequired,
  sliceId: PropTypes.number.isRequired,
};

Articles.defaultProps = {
  className: undefined,
};

const mapStateToProps = (state, { sliceId }) => ({
  ready: isEditionTrayReadyOrError(state, sliceId),
});

export default compose(
  connect(mapStateToProps),

  injectSheet({
    articles: containerStyle,
    article: {}, // required for SideScroller’s slideClassName prop
  }),
)(Articles);
